import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";

export default function GetNylasAuth({ showAddModal }) {
  /*   All States
   ********************************************* */
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const [authUrl, setAuthUrl] = useState(null);

  /*   All Functions
   ********************************************* */

  const getAuthUrl = async () => {
    try {
      setLoading(true);
      const { data } = await API.get("/email-grants/auth/url", {
        headers: authHeader(),
      });
      if (data?.success && data?.authUrl) {
        setAuthUrl(data.authUrl);
      } else {
        throw new Error("Failed to get authorization URL");
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    }
  };

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    let timeout = setTimeout(() => {
      if (showAddModal) {
        setAuthUrl(null);
        getAuthUrl();
      }
    }, 50);
    return () => clearTimeout(timeout);
  }, [showAddModal]);
  return (
    <div
      // style={{ marginLeft: 260, height: "100vh", overflow: "auto" }}
      className="p-4"
    >
      {loading && <Spinner />}
      <div className="card shadow-none h-100">
        <div className="card-body flex-center flex-column">
          {!authUrl ? (
            <div className="text-center">
              <p className="card-text">Generating Url...</p>
            </div>
          ) : (
            <div className="text-center">
              <h2 className="card-title">Get Nylas Authorization</h2>
              <p className="card-text">
                To connect your email account, please click the button below to
                authorize via Nylas.
              </p>
              <a href={authUrl} className="btn btn-primary">
                Authorize with Nylas
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
